import { lazy } from 'react';

export const ErrorRoutes = {
  ErrorPage: lazy(() =>
    import('@/modules/Error/pages/ErrorPage').then(({ ErrorPage }) => ({
      default: ErrorPage,
    })),
  ),
};
